export default __webpack_public_path__ + "static/media/avatar.3c0f1f4b.png";